<template>
  <section>

  <div v-if="loading">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">

        <!-- Edit -->
        <div class="intro-y box">
          <div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200">
            <h2 class="font-medium text-base mr-auto">
              Editar Proyecto
            </h2>
          </div>
            <form class="p-5 grid grid-cols-12 gap-2"  @submit.prevent="putProject">
              <div class="col-span-6 sm:col-span-6">
                  <label for="msg">Nombre</label>
                  <input v-on:input="updateValue('name',$event)" type="text"
                  class="input w-full border mt-2" :value="project.name" >
              </div>
              <div class="col-span-6 sm:col-span-6">
                  <label>Cuenta</label>
                  <select class="input w-full border mt-2" v-on:input="updateValue('account_id',$event)"
                      :value="project.account_id" required>
                      <option disabled>Seleccione la cuenta</option>
                      <option v-for="account in accounts" v-bind:value="account.id">
                        {{account.name}}
                      </option>
                  </select>
              </div>
              <div class="col-span-4 sm:col-span-4 mt-3">
                  <label>Usuario</label>
                  <select class="input w-full border mt-2" v-on:input="updateValue('user_id',$event)"
                      :value="project.user_id" required>
                      <option disabled>Seleccione el usuario</option>
                      <option v-for="user in users" v-bind:value="user.id">
                        {{user.name}}
                      </option>
                  </select>
              </div>
              <div class="col-span-4 sm:col-span-4 mt-3">
                  <label for="msg">Estado</label>
                  <select class="input w-full border mt-2" v-on:input="updateValue('status',$event)"
                      :value="project.status" required>
                      <option disabled>Seleccione el usuario</option>
                      <option value="0">Inactivo</option>
                      <option value="1">Activo</option>
                  </select>
              </div>
              <div class="col-span-4 sm:col-span-4 mt-3">
                  <label for="msg">Horas (Digital)</label>
                  <input v-on:input="updateValue('hours',$event)" type="text"
                  class="input w-full border mt-2" :value="project.hours" >
              </div>
              <div class="col-span-12 mt-3">
                  <button type="submit" id="edit" class="button w-24 bg-theme-1 text-white">
                    Modificar
                  </button>
              </div>
            </form>
          </div>
          <!-- END: Edit -->

        </div>
      </div>
    </div>

    <app-loading  v-else />

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Loading from '@/components/admin/partials/LoadingWhite'

export default {
  name: 'EditProject',
  data () {
    return {
      loading: false,
      view: {
        entity: 'project',
        id: this.$route.params.id
      },
      aux_project: { entity: 'project' }
    }
  },
  computed: {
    ...mapGetters({
      project: 'getProject',
      users: 'getUsers',
      accounts: 'getAccounts'
    })
  },
  beforeMount () {
    this.show(this.view)
    .then(() => {
      this.loading = true
    })
    this.getList('user')
    .then(() => {
      this.loading = true
    }),
    this.getList('account')
    .then(() => {
      this.loading = true
    })
  },
  methods: {
      putProject () {
        var vm = this
        vm.loading = false
        window.$('#edit').button('loading')
        vm.aux_project.id = vm.project.id
        vm.update(vm.aux_project).then(project => {
          vm.loading = true
          vm.$router.replace(vm.$route.query.redirect || '/admin/traffic/projects')
        })
        .catch(message => {
          window.$('#edit').button('reset')
          vm.loading = true
        })
      },
      updateValue (attribute, e) {
        this.aux_project[attribute] = e.target.value
      },
      ...mapActions([
         'show',
         'getAll',
         'getList',
         'update'
       ])
  },
  components: {
    appLoading: Loading
  }
}
</script>



// WEBPACK FOOTER //
// EditProject.vue?0ce136a3